import { createContext, useContext } from "react";

import { defaultFeatureFlagsContext } from "@/contexts/featureFlags/constants";

import { type FeatureFlagsContextType } from "./types";

const FeatureFlagsContext = createContext<FeatureFlagsContextType>(
  defaultFeatureFlagsContext,
);

interface FeatureFlagsContextProviderProps {
  children: React.ReactNode;
  value?: FeatureFlagsContextType;
}

export function FeatureFlagsContextProvider({
  children,
  value = defaultFeatureFlagsContext,
}: Readonly<FeatureFlagsContextProviderProps>) {
  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useFeatureFlags = (): FeatureFlagsContextType =>
  useContext(FeatureFlagsContext);
